@if (component) {
  <ion-card button (click)="presentModal()" (keydown.enter)="presentModal()" tabindex="0">
    <ion-item lines="full" color="light">
      <ion-icon slot="start" size="large" color="normal" name="trending-down-outline"></ion-icon>
      <ion-label>{{ component.alias }}</ion-label>
    </ion-item>
    @if ((edge.currentData | async)['channel']; as currentData) {
      <ion-card-content class="underline">
        <ng-container>
          <table class="full_width">
            <tr>
              <td style="width: 65%" translate>
                EDGE.INDEX.WIDGETS.DELAYED_SELL_TO_GRID.SELL_TO_GRID_POWER_LIMIT
              </td>
              <td style="width: 35%" class="align_right">
                {{ (component.properties.sellToGridPowerLimit) | unitvalue:'kW' }}
              </td>
            </tr>
            <tr>
              <td style="width: 65%" translate>
                EDGE.INDEX.WIDGETS.DELAYED_SELL_TO_GRID.CONTINUOUS_SELL_TO_GRID_POWER
              </td>
              <td style="width: 35%" class="align_right">
                {{ (component.properties.continuousSellToGridPower) | unitvalue:'kW' }}
              </td>
            </tr>
          </table>
        </ng-container>
      </ion-card-content>
    }
  </ion-card>
}